// =========================================================
// frontend/js/company-status-arten.js
// =========================================================
/**
 * ANSICHT: STATUS-ARTEN TABELLE
 * Wird von app.js / admin.js aufgerufen, wenn activeSubView === 'status_types'
 */ window.renderStatusTypesTab = function() {
    // Greife auf die global geladenen Status-Arten zu (oder nutze ein leeres Array als Fallback)
    const statuses = window.statusTypes || [];
    return `
        <div class="p-12 max-w-5xl animate-fadeIn">
            <div class="flex justify-between items-end mb-8">
                <div>
                    <h3 class="text-4xl font-black text-slate-800 tracking-tighter">Status-Arten</h3>
                    <p class="text-xs text-slate-400 font-bold uppercase tracking-widest mt-2">Definition von Buchungs- & Vorgangsstatus</p>
                </div>
                <button onclick="window.openStatusTypeModal()" class="bg-blue-600 text-white px-8 py-4 rounded-2xl font-black text-xs uppercase tracking-widest shadow-xl hover:bg-black transition-all">
                    <i data-lucide="plus" class="w-4 h-4 inline mr-2"></i> Neuer Status
                </button>
            </div>

            <div class="bg-white rounded-[3rem] border border-slate-200 shadow-sm overflow-hidden min-h-[400px]">
                <div class="grid grid-cols-[auto_1fr_1fr_auto_auto] gap-4 p-6 bg-slate-50 border-b border-slate-200 text-[10px] font-black text-slate-400 uppercase tracking-widest">
                    <div class="w-12 text-center">Icon</div>
                    <div>Name & Farbe</div>
                    <div>Sichtbarkeit</div>
                    <div class="text-center">Anwesenheit</div>
                    <div class="text-right">Aktionen</div>
                </div>
                <div class="divide-y divide-slate-100">
                    ${statuses.length === 0 ? `
                        <div class="p-12 text-center text-slate-400 font-bold">
                            Noch keine Status-Arten angelegt. Klicke auf "Neuer Status".
                        </div>
                    ` : statuses.map((st)=>`
                        <div class="grid grid-cols-[auto_1fr_1fr_auto_auto] gap-4 p-6 items-center hover:bg-slate-50 transition-colors ${!st.isActive ? 'opacity-50 grayscale' : ''}">
                            <div class="w-12 h-12 rounded-2xl flex items-center justify-center text-white shadow-sm" style="background-color: ${st.color || '#94a3b8'}">
                                <i data-lucide="${st.icon || 'tag'}" class="w-5 h-5"></i>
                            </div>
                            <div>
                                <p class="font-black text-slate-800 text-base">${st.name}</p>
                                <p class="text-[10px] text-slate-400 font-bold uppercase tracking-widest">${st.isActive ? 'Aktiv' : 'Deaktiviert'}</p>
                            </div>
                            <div class="text-sm font-bold text-slate-600">
                                ${st.visibility || 'Alle'}
                            </div>
                            <div class="text-center">
                                ${st.isMandatory ? '<span class="bg-rose-100 text-rose-600 px-3 py-1 rounded-xl text-[10px] font-black uppercase">Ja</span>' : '<span class="text-slate-300">-</span>'}
                            </div>
                            <div class="flex justify-end gap-2">
                                <button onclick="window.openStatusTypeModal('${st.id}')" title="Bearbeiten" class="p-3 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-2xl transition-all">
                                    <i data-lucide="edit-2" class="w-5 h-5"></i>
                                </button>
                            </div>
                        </div>
                    `).join('')}
                </div>
            </div>
        </div>
        <div id="status-modal-container"></div>
    `;
};
/**
 * HILFSFUNKTION FÜR DAS MODAL: Schreibt das Icon ins Feld
 */ window.selectStatusIcon = function(iconName) {
    document.getElementById('st-icon').value = iconName;
    document.getElementById('st-icon-preview').setAttribute('data-lucide', iconName);
    if (window.lucide) lucide.createIcons();
};
/**
 * MODAL: STATUS ANLEGEN / BEARBEITEN (Mit interaktiver Icon-Galerie)
 */ window.openStatusTypeModal = function(statusId = null) {
    const st = statusId && window.statusTypes ? window.statusTypes.find((s)=>s.id === statusId) : {};
    const isNew = !statusId;
    // Eine kleine Auswahl beliebter/passender Kalender- & Office-Icons
    const iconGallery = [
        'tag',
        'home',
        'building',
        'briefcase',
        'coffee',
        'clock',
        'calendar',
        'calendar-clock',
        'palmtree',
        'sun',
        'umbrella',
        'thermometer',
        'stethoscope',
        'heart-pulse',
        'pill',
        'car',
        'plane',
        'train',
        'bus',
        'graduation-cap',
        'book',
        'monitor',
        'laptop',
        'smartphone',
        'phone-call',
        'users',
        'star',
        'award',
        'party-popper',
        'cake',
        'globe',
        'map-pin'
    ];
    const modalHTML = `
        <div id="status-modal" class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[200] flex items-center justify-center p-4 animate-fadeIn">
            <div class="bg-white rounded-[3rem] shadow-2xl w-full max-w-2xl flex flex-col max-h-[90vh]">
                
                <div class="p-10 border-b border-slate-100 shrink-0 bg-slate-50 rounded-t-[3rem]">
                    <h3 class="text-2xl font-black text-slate-800 flex items-center gap-3">
                        <i data-lucide="tags" class="text-blue-600"></i> ${isNew ? 'Neuen Status anlegen' : 'Status bearbeiten'}
                    </h3>
                </div>

                <div class="p-8 overflow-y-auto space-y-6 flex-1">
                    <div class="grid grid-cols-2 gap-6">
                        <div>
                            <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-2">Status Name</label>
                            <input type="text" id="st-name" value="${st.name || ''}" class="w-full bg-slate-50 border border-slate-200 rounded-2xl px-6 py-4 font-bold text-slate-700 outline-none focus:border-blue-500 transition-all" placeholder="z.B. Home-Office, Urlaub...">
                        </div>
                        <div>
                            <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-2">Icon ausw\xe4hlen</label>
                            <div class="flex gap-2">
                                <div class="w-14 h-14 bg-slate-100 border border-slate-200 rounded-2xl flex items-center justify-center text-slate-500 shrink-0">
                                    <i id="st-icon-preview" data-lucide="${st.icon || 'tag'}" class="w-6 h-6"></i>
                                </div>
                                <input type="text" id="st-icon" value="${st.icon || 'tag'}" oninput="window.selectStatusIcon(this.value)" class="w-full bg-slate-50 border border-slate-200 rounded-2xl px-4 py-4 font-bold text-slate-700 outline-none focus:border-blue-500 transition-all" placeholder="Lucide Name...">
                            </div>
                        </div>
                    </div>

                    <div class="bg-slate-50 border border-slate-200 rounded-2xl p-4">
                        <p class="text-[9px] font-black text-slate-400 uppercase tracking-widest mb-3 ml-1">Schnellauswahl</p>
                        <div class="flex flex-wrap gap-2">
                            ${iconGallery.map((ic)=>`
                                <button onclick="window.selectStatusIcon('${ic}')" title="${ic}" class="w-10 h-10 bg-white border border-slate-200 rounded-xl flex items-center justify-center text-slate-500 hover:text-blue-600 hover:border-blue-400 hover:bg-blue-50 transition-all shadow-sm">
                                    <i data-lucide="${ic}" class="w-5 h-5"></i>
                                </button>
                            `).join('')}
                        </div>
                    </div>

                    <div class="grid grid-cols-2 gap-6 pt-4 border-t border-slate-100">
                        <div>
                            <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-2">Farbe (HEX)</label>
                            <div class="flex gap-3">
                                <input type="color" id="st-color" value="${st.color || '#3b82f6'}" class="w-14 h-14 rounded-2xl cursor-pointer border-0 p-0 bg-transparent">
                                <input type="text" id="st-color-text" value="${st.color || '#3b82f6'}" class="flex-1 bg-slate-50 border border-slate-200 rounded-2xl px-4 py-4 font-bold text-slate-700 outline-none focus:border-blue-500 transition-all uppercase">
                            </div>
                        </div>
                        <div>
                            <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 ml-2">Sichtbarkeit</label>
                            <select id="st-visibility" class="w-full bg-slate-50 border border-slate-200 rounded-2xl px-6 py-4 font-bold text-slate-700 outline-none focus:border-blue-500 transition-all">
                                <option value="Alle" ${st.visibility === 'Alle' ? 'selected' : ''}>F\xfcr Alle sichtbar</option>
                                <option value="Nur Admins" ${st.visibility === 'Nur Admins' ? 'selected' : ''}>Nur Admins & HR</option>
                                <option value="Versteckt" ${st.visibility === 'Versteckt' ? 'selected' : ''}>System (Versteckt)</option>
                            </select>
                        </div>
                    </div>

                    <div class="mt-8 space-y-4">
                        <label class="flex items-center justify-between p-5 bg-white border border-slate-200 rounded-[1.5rem] cursor-pointer hover:border-blue-300 transition-colors shadow-sm">
                            <div>
                                <span class="font-bold text-slate-700 text-sm">Anwesenheitspflicht (Mandatory)</span>
                                <p class="text-[10px] text-slate-400 font-bold mt-1">Gilt dieser Status als Anwesenheit vor Ort (z.B. f\xfcr Auswertungen)?</p>
                            </div>
                            <input type="checkbox" id="st-mandatory" class="w-6 h-6 text-rose-600 rounded focus:ring-rose-500 border-slate-300" ${st.isMandatory ? 'checked' : ''}>
                        </label>

                        <label class="flex items-center justify-between p-5 bg-white border border-slate-200 rounded-[1.5rem] cursor-pointer hover:border-blue-300 transition-colors shadow-sm">
                            <div>
                                <span class="font-bold text-slate-700 text-sm">Status Aktiv</span>
                                <p class="text-[10px] text-slate-400 font-bold mt-1">Kann dieser Status von Mitarbeitern ausgew\xe4hlt werden?</p>
                            </div>
                            <input type="checkbox" id="st-active" class="w-6 h-6 text-emerald-600 rounded focus:ring-emerald-500 border-slate-300" ${isNew || st.isActive ? 'checked' : ''}>
                        </label>
                    </div>
                </div>

                <div class="p-8 flex gap-4 border-t border-slate-100 bg-white rounded-b-[3rem] shrink-0">
                    <button onclick="window.saveStatusType('${statusId || ''}')" class="flex-1 bg-blue-600 text-white py-4 rounded-2xl font-black text-xs uppercase tracking-widest hover:bg-black transition-all shadow-xl">
                        ${isNew ? 'Status anlegen' : "\xc4nderungen speichern"}
                    </button>
                    <button onclick="document.getElementById('status-modal').remove()" class="px-8 py-4 bg-slate-50 border border-slate-200 text-slate-600 font-bold rounded-2xl hover:bg-slate-100 transition-all">Abbrechen</button>
                </div>
            </div>
        </div>
    `;
    document.getElementById('status-modal-container').innerHTML = modalHTML;
    // Farb-Picker synchronisieren (Input Color <-> Input Text)
    const colorPicker = document.getElementById('st-color');
    const colorText = document.getElementById('st-color-text');
    colorPicker.addEventListener('input', (e)=>colorText.value = e.target.value.toUpperCase());
    colorText.addEventListener('input', (e)=>colorPicker.value = e.target.value);
    if (window.lucide) lucide.createIcons();
};
/**
 * LOGIK: SPEICHERN
 */ window.saveStatusType = async function(statusId) {
    const name = document.getElementById('st-name').value.trim();
    const icon = document.getElementById('st-icon').value.trim() || 'tag';
    const color = document.getElementById('st-color').value;
    const visibility = document.getElementById('st-visibility').value;
    const isMandatory = document.getElementById('st-mandatory').checked;
    const isActive = document.getElementById('st-active').checked;
    if (!name) return alert("Bitte vergib einen Namen f\xfcr den Status!");
    // Objekt zusammenbauen
    const statusData = {
        id: statusId || 'status_' + Date.now().toString(36),
        name: name,
        icon: icon,
        color: color,
        visibility: visibility,
        isMandatory: isMandatory,
        isActive: isActive,
        updatedAt: new Date().toISOString()
    };
    try {
        // Lokale Liste aktualisieren (für sofortiges UI-Feedback)
        if (!window.statusTypes) window.statusTypes = [];
        const existingIndex = window.statusTypes.findIndex((s)=>s.id === statusData.id);
        if (existingIndex > -1) window.statusTypes[existingIndex] = statusData;
        else window.statusTypes.push(statusData);
        // HIER KOMMT SPÄTER DER API-CALL REIN
        if (typeof window.saveStatusTypeToDB === 'function') await window.saveStatusTypeToDB(window.currentUser.companyId, statusData);
        // Modal schließen und UI neu rendern
        document.getElementById('status-modal').remove();
        if (window.showToast) window.showToast("Status erfolgreich gespeichert!");
        window.render();
    } catch (error) {
        console.error("Fehler beim Speichern:", error);
        alert("Es gab einen Fehler beim Speichern.");
    }
};

//# sourceMappingURL=frontend.76bcea0c.js.map
